module.exports = __webpack_public_path__ + "static/img/bk_car.ec68bbec.jpg";